import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

import "../globals.css";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://831a4844c1ea93d5a69d81a4b38b2338@o4509074795397120.ingest.us.sentry.io/4509135602450432",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/(staging.)?s-process\.app/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: import.meta.env.MODE,
    normalizeDepth: 10, // Maximum number of levels that normalization algorithm will traverse in objects and arrays (e.g. in attached contexts)
    tunnel: "/tunnel",
  });
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />,
);
